module.exports = __webpack_public_path__ + "img/kraken.bb616cc1.png";